import { CONDITION_CONFIRMATION_LIST_VARIANTS, CONDITION_RUN_ACTION_TYPE_LIST, ConditionTypeExtended } from "@/constants/robotConfigLists";
import { ConditionType } from "@/types/ses/sesItemConfigTypes";
import { faBan, faCalendarCheck, faClock, faDatabase, faPenToSquare, faThumbsDown, faThumbsUp, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export const CONDITIONS_LIST_ICONS: Record<Exclude<ConditionTypeExtended, "or"> | "yes" | "no", IconDefinition | string> = {
	interval: faClock,
	variable: "{ }",
	data: faDatabase,
	confirmation: faThumbsUp,
	break: faBan,
	yes: faThumbsUp,
	no: faThumbsDown,
	event: faCalendarCheck,
	chooseType: faPenToSquare,
};

export const CONDITIONS_LIST: { value: "interval" | "variable" | "data" | "confirmation" | "break" | "event" | "chooseType" | "yes" | "no"; label: string }[] = [
	{ value: "chooseType", label: "selectItem_selectType" },
	...CONDITION_RUN_ACTION_TYPE_LIST.filter((el): el is { type: Exclude<ConditionType, "or">; translation: string } => el.type !== "confirmation" && el.type !== "or").map(
		(el) => ({ value: el.type, label: el.translation })
	),
	...CONDITION_CONFIRMATION_LIST_VARIANTS.filter((el): el is { value: "yes" | "no"; translation: string } => el.value === "yes" || el.value === "no").map((el) => ({
		value: el.value,
		label: el.translation,
	})),
];
